<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					
					<el-form-item label="UID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.uid" placeholder="请输入UID"></el-input>
					</el-form-item>
					<el-form-item label="用户名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="订单号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.orderCode" placeholder="请输入订单号">
						</el-input>
					</el-form-item>
					<el-form-item label="订单状态" label-width="80px">
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="0" label="待付款" :value="0">待付款</el-option>
							<el-option key="1" label="待发货" :value="1">待发货</el-option>
							<el-option key="2" label="待收货" :value="2">待收货</el-option>
							<el-option key="3" label="已完成" :value="3">已完成</el-option>
							<el-option key="4" label="退款申请" :value="4">退款申请</el-option>
							<el-option key="5" label="已退款" :value="5">已退款</el-option>
							<el-option key="6" label="部分退款" :value="6">部分退款</el-option>
							<el-option key="7" label="已失效" :value="7">已失效</el-option>
							<el-option key="8" label="驳回" :value="8">驳回</el-option>
							<el-option key="9" label="取消" :value="9">取消</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单类别" label-width="80px">
						<el-select v-model="searchInfo.type" placeholder="请选择">
							<el-option key="0" label="商城订单" :value="0">商城订单</el-option>
							<el-option key="1" label="共享订单" :value="16">共享订单</el-option>
							<el-option key="2" label="活动订单" :value="17">活动订单</el-option>
							<el-option key="3" label="兑换订单" :value="19">兑换订单</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择店铺">
						<el-select v-model="searchInfo.storeName" class="big" placeholder="请选择"
							@change="getStoreName">
							<el-option v-for="item in selectStoreName" :key="item.id" :value="item.id"
								:label="item.storeName">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="选择供应商" v-if="this.storeNameId">
						<el-select v-model="searchInfo.supplierName"  class="big" placeholder="请选择"
							@change="getStoreAndUser">
							<el-option v-for="item in accountList" :key="item.id" :value="item.id"
								:label="item.supplierName">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="供应商名称:" label-width="90px">
						<el-input style="width: 200px;" v-model="searchInfo.supplierName" placeholder="请输入供应商名称">
						</el-input>
						<el-select v-model="searchInfo.storeName" placeholder="请选择">
							<el-option v-for="item in orderList" :key="item.id" :label="item.storeName"
								:value="item.storeId">
							</el-option>
						</el-select>
					</el-form-item> -->
					<!-- 					<el-form-item label="订单类型:" label-width="80px">
						<el-select v-model="searchInfo.type" placeholder="请选择">
							<el-option key="0" label="商城订单" :value="0">商城订单</el-option>
							<el-option key="1" label="兑换订单" :value="1">兑换订单</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="所属区域:" label-width="80px">
						<el-select clearable filterable v-model="searchInfo.provinceId" placeholder="请选择省"
							@change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.cityId" placeholder="请选择市"
							@change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="searchInfo.areaId" placeholder="请选择区"
							@change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile">
								导出
								<a href=""></a>
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="orderList" stripe style="width: 100%" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
			<el-table-column type="index" align="center" width="50" label="#">
			</el-table-column>
			<el-table-column prop="id" label="订单ID" align="center" width="90" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="type" label="订单类别" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.type==0">商城订单</span>
					<span v-if="scope.row.type==19">兑换订单</span>
					<span v-if="scope.row.type==16">共享小超</span>
					<span v-if="scope.row.type==17">活动小超</span>
				</template>
			</el-table-column>
			<el-table-column prop="username" label="用户名" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeName" label="店铺名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="supplierName" label="供应商名称" align="center" width="90" :show-overflow-tooltip="true">
			</el-table-column> -->
		
			<el-table-column prop="orderCode" label="订单号" align="center" width="220" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="orderTotalPrice" label="订单总价(￥)" align="center" width="120"
				:show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="订单状态" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==0">待付款</span>
					<span v-if="scope.row.status==1">待发货</span>
					<span v-if="scope.row.status==2">待收货</span>
					<span v-if="scope.row.status==3">已完成</span>
					<span v-if="scope.row.status==4">退款申请</span>
					<span v-if="scope.row.status==5">已退款</span>
					<span v-if="scope.row.status==6">部分退款</span>
					<span v-if="scope.row.status==7">已失效</span>
					<span v-if="scope.row.status==8">驳回</span>
					<span v-if="scope.row.status==9">取消</span>
				</template>
			</el-table-column>
			<!-- 			<el-table-column prop="address" label="所属区域" align="center" width="180" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="address" label="详细地址" align="center" width="180" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center"   width="150" >
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row)">查看详情</el-button>
					<el-button v-if="scope.row.status==1" size="small" type="text" @click="showDeliver(scope.row)">发货
					</el-button>
					
					<!-- <el-button v-if="type==1" size="small" type="text" @click="showDeliver(scope.row)">发货
					</el-button>
					<el-button v-if="type !=1 && storeId == scope.row.storeId" size="small" type="text" @click="showDeliver(scope.row)">发货
					</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 订单详情对话框 -->
		<el-dialog title="订单详情" :visible.sync="dialogVisible" width="60%" :before-close="handleClose"
			:close-on-click-modal="false">
			<div>
				<div style="margin:10px 0 ;">
					<strong>商品详情</strong>&nbsp;&nbsp;&nbsp;&nbsp;
				</div>

				<div class="orderList">
					<div class="orderxq" v-for="(item,index) in orderInfo.goodsList" :key="index">
						<div>
							<img :src="item.images.split(',')[0]" alt="" style="width:100px;height:100px;">
						</div>
						<div style="margin-left:20px;">
							<p>商品名称：{{item.goodsName}}</p>
							<p>供应商名称：{{orderInfo.supplierName}}</p>
							<p>购买数量：{{item.num}}</p>
							<p>单价：{{item.price}}</p>
						</div>
					</div>
				</div>
				<el-form v-model="orderInfo" label-position="left" inline class="demo-table-expand">
					<el-form-item label="订单号">
						<span>{{orderInfo.orderCode?orderInfo.orderCode:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="支付类型">
						<span v-if="orderInfo.payType=='wx'">微信支付</span>
						<span v-if="orderInfo.payType=='Ali_Pay'">支付宝支付</span>
						<span v-if="orderInfo.payType=='integral'">积分抵扣-{{orderInfo.coinName}}</span>
						<span v-if="orderInfo.payType=='wx_plural'">微信积分混合支付</span>
						<span v-if="orderInfo.payType=='huiJu_Ali_Pay'">汇聚支付宝支付</span>
						<span v-if="orderInfo.payType=='huiJu_Quick_Pay'">汇聚快捷支付</span>
						<span v-if="orderInfo.payType=='yl_wxapplet_pay'">银联微信支付</span>
					</el-form-item>
					<el-form-item label="所属区域">
						<span>{{orderInfo.province}}{{orderInfo.city}}{{orderInfo.area}}</span>
					</el-form-item>
					<el-form-item label="订单状态">
						<span v-if="orderInfo.status==0">待付款</span>
						<span v-if="orderInfo.status==1">待发货</span>
						<span v-if="orderInfo.status==2">待收货</span>
						<span v-if="orderInfo.status==3">已完成</span>
						<span v-if="orderInfo.status==4">退款申请</span>
						<span v-if="orderInfo.status==5">已退款</span>
						<span v-if="orderInfo.status==6">部分退款</span>
						<span v-if="orderInfo.status==7">已失效</span>
						<span v-if="orderInfo.status==8">驳回</span>
						<span v-if="orderInfo.status==9">取消</span>
					</el-form-item>
					<el-form-item label="订单总价">
						<span>{{orderInfo.orderTotalPrice?"￥"+orderInfo.orderTotalPrice:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="支付金额">
						<span>{{orderInfo.cashNum?"￥"+orderInfo.cashNum:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="积分抵扣">
						<span>{{orderInfo.integralNum?"￥"+orderInfo.integralNum:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="收货人">
						<span>{{orderInfo.name?orderInfo.name:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="联系电话">
						<span>{{orderInfo.phone?orderInfo.phone:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="详细地址">
						<span>{{orderInfo.province}}{{orderInfo.city}}{{orderInfo.area}}{{orderInfo.address}}</span>
					</el-form-item>
					<el-form-item label="购买时间">
						<span>{{orderInfo.createTime?orderInfo.createTime:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="快递公司">
						<span>{{orderInfo.expressName?orderInfo.expressName:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="快递单号">
						<span>{{orderInfo.expressCode?orderInfo.expressCode:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="发货人">
						<span>{{orderInfo.sendOpUser?orderInfo.sendOpUser:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="发货时间">
						<span>{{orderInfo.sendTime?orderInfo.sendTime:'暂无'}}</span>
					</el-form-item>
					<el-form-item label="确认收货时间">
						<span>{{orderInfo.completeTime?orderInfo.completeTime:'暂未确认'}}</span>
					</el-form-item>
					<el-form-item label="备注">
						<span>{{orderInfo.remark?orderInfo.remark:'暂无'}}</span>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
			</span>
		</el-dialog>
		<!-- 发货 -->
		<el-dialog style="float:rigin" title="发货" :visible.sync="deliverDialog" width="30%"
			:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<el-form-item label="订单号:">
						<span>{{orderCode}}</span>
					</el-form-item>
					<el-form-item label="收货人:">
						<span>{{name}}</span>
					</el-form-item>
					<el-form-item label="收货地址:">
						<span>{{address}}</span>
					</el-form-item>
					<!-- <el-form-item label="物流:">
						<el-col :span="12">
							<el-select clearable filterable v-model="expressId" class="big" placeholder="请选择" clear>
								<el-option v-for="item in expressList" :key="item.id" :value="item.id"
									:label="item.expressName">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item> -->
					<el-form-item label="发货方式:">
						<el-col :span="12">
							<el-select clearable filterable v-model="fhtype" 
							class="big" placeholder="请选择发货方式" >
								
								<el-option :value='0'
									label="物流">
								</el-option>
								<el-option :value='1'
									label="自提">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="物流:" v-if="fhtype==0">
						<el-col :span="12">
							<el-select clearable filterable v-model="expressId" class="big" placeholder="请选择" clear>
								
								<el-option v-for="item in expressList" :key="item.id" :value="item.id"
									:label="item.expressName">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>
					<el-form-item label="快递单号:" v-if="fhtype==0">
						<el-col :span="15">
							<el-input type="text" v-model="expressCode" placeholder="请输入快递单号" />
						</el-col>
					</el-form-item>
					<!-- <el-form-item label="发货人:">
						<el-col :span="15">
							<el-input type="text" v-model="sendOpUser" placeholder="请输入发货人" />
						</el-col>
					</el-form-item> -->
					<el-form-item label="发货备注:">
						<el-col :span="15">
							<el-input type="text" v-model="sendRemark" placeholder="请输入发货备注(非必填)" />
						</el-col>
					</el-form-item>
					
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="deliverDialog = false">取 消</el-button>
				<el-button type="primary" @click="deliverGoods">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				orderList: [],
				dialogVisible: false,
				searchInfo: {},
				orderCode:'',
				orderInfo: {},
				sliderlist: {},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				deliverDialog: false, //发货弹窗
				sendRemark: '', // 发货备注
				sendOpUser: '', // 发货人
				expressCode: '', // 快递订单号
				expressId: '', // 快递公司id
				expressList: [], //快递公司列表
				showOrderInfo: [], //发货订单信息
				accountList: [],
				fhtype:'',
				name:'',
				address:'',
				storeId:'', //登录者id
				type:'', // 登录者身份
				selectStoreName:[], //选择店铺的店铺列表
				accountList1:[],
				storeNameId:'', //店铺iD
				supplierId:'', // 供应商id 
			};
		},
		methods: {
			/**
			 * 文件导出
			 */
			downloadFile() {
				let data = {
					username: this.searchInfo.username,
					orderCode: this.searchInfo.orderCode,
					status: this.searchInfo.status,
					type: this.searchInfo.type,
					provinceId: this.searchInfo.provinceId,
					cityId: this.searchInfo.cityId,
					areaId: this.searchInfo.areaId,
					userId: this.searchInfo.uid,
					// supplierId: this.searchInfo.supplierId,
					supplierName: this.searchInfo.supplierName,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.exportExcelHistory(data).then((res) => {
					console.log(res.data)
					this.showloadFile(res.data)
				})
			},
			getStoreAndUser(e){
				console.log(e);
				this.supplierId = e
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				console.log(obj);
				this.searchInfo.supplierName = obj.supplierName
			},
			getStoreName(e){
				console.log(e);
				
				this.storeNameId = e
				console.log(this.selectStoreName);
				console.log(this.storeName);
				let obj = {};
				obj = this.selectStoreName.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				console.log(obj);
				this.searchInfo.storeName = obj.storeName
				this.accountList = []
				if(e){
					this.$api.supplierNameList(this.$encrypt({storeId:e})).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						if(res.state == 'success'){
							this.accountList = res.data
						}
					})
				}
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '商城订单' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			//确认发货
			deliverGoods() {
				if(this.fhtype==1){
					var data = {
						
						sendRemark: this.sendRemark,
						expressId: 1,
						storeId: this.showOrderInfo.storeId,
						status: 3,
						id: this.showOrderInfo.id
					}
				}else{
					var data = {
						expressCode: this.expressCode,
						sendRemark: this.sendRemark,
						sendOpUser: this.sendOpUser,
						expressId: this.expressId,
						storeId: this.showOrderInfo.storeId,
						status: 2,
						id: this.showOrderInfo.id
					}
				}
				// var data = {
				// 	expressCode: this.expressCode,
				// 	sendOpUser: this.sendOpUser,
				// 	expressId: this.expressId,
				// 	storeId: this.showOrderInfo.storeId,
				// 	status: 2,
				// 	id: this.showOrderInfo.id
				// }
				this.$api.editStoreOrderStatusHistory(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.fhtype==0
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.storeOrderListHistory();
						this.deliverDialog = false
					} else {
						this.$message.error(res.message);
					}
				})

			},
			//快递公司列表
			findExpress() {
				this.$api.findAllOrderExpressList({}).then((res) => {
					if (res.state == 'success') {
						this.expressList = res.data.list
					}
				})
			},
			//展示发货弹窗
			showDeliver(item) {
				console.log(item);
				this.fhtype=0
				
				this.showOrderInfo = []
				this.expressCode = ""
				this.sendRemark = ""
				this.sendOpUser = ""
				this.expressId = ""
				this.findExpress();
				this.showOrderInfo = item
				this.deliverDialog = true
				this.orderCode=item.orderCode
				this.name=item.name+"-"+item.phone
				this.address=item.address
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderListHistory()
			},
			// 清空
			empty() {
				this.searchInfo = {}

			},
			storeOrderListHistory() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					username: this.searchInfo.username,
					storeId: this.storeNameId,
					orderCode: this.searchInfo.orderCode,
					status: this.searchInfo.status,
					type: this.searchInfo.type,
					provinceId: this.searchInfo.provinceId,
					cityId: this.searchInfo.cityId,
					areaId: this.searchInfo.areaId,
					supplierId: this.supplierId,
					userId: this.searchInfo.uid,
					// supplierName: this.searchInfo.supplierName,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.storeOrderListPcHistory(this.$encrypt(data)).then((res => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.orderList = res.data.list
						console.log(this.orderList);
						this.sliderlist = res.data
						this.loading = false
					}
				}))
				//查询省
				this.$api.getArea(0).then((res) => {
					if (res.state == 'success') {
						this.provinceList = res.data
					}
				})
			},
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.province = obj.name
				this.orderInfo.cityId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.city = obj.name
				this.districtList = {}
				if (e) {
					this.$api.getArea(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}

			},

			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
			},
			// 订单详情查询
			showContent(e) {
				let data = {
					id: e.id,
					areaId: e.areaId,
					provinceId: e.provinceId,
					cityId: e.cityId
				}
				this.$api.findOrderInfoHistory(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.orderInfo = res.data
						this.dialogVisible = true
					} else {
						this.$message.error(res.message)
					}
				})
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderListHistory();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderListHistory()
			},
			// searchStore() {
			// 	let data = {}
			// 	this.$api.supplier(data).then((res) => {
			// 		console.log(res);
			// 		if (res.state == 'success') {
			// 			//此行代码会出现供应商错误
			// 			// this.storeGoodsInfo.storeId = res.data.list[0].id
			// 			this.accountList = res.data;
			// 		} else {
			// 			this.$message.error(res.message);
			// 		}
			// 	})
			// },
			selectStore(){
				this.$api.selectStoreList().then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if(res.state == 'success'){
						this.selectStoreName = res.data
					}else {
						this.$message.error(res.message);
					}
				})
			},
		},

		created() {
			// this.storeId = sessionStorage.getItem('storeId')
			// this.type = sessionStorage.getItem('type')
			// console.log(this.storeId,this.type);
			this.storeOrderListHistory();
			// this.searchStore();
			this.selectStore();
		},
	};
</script>

<style>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;

	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

	}
</style>
